import useGetExaminationSolutionDetail, {
  QmsExamItemType,
} from './useGetExaminationSolutionDetail';

export type { QmsExamItemType };
export default useGetExaminationSolutionDetail;
